import React from 'react';
import Hide from '@uber/base-icons/hide';
import Lock from '@uber/base-icons/lock';
import { styled, useStyletron } from 'baseui';
import { PLACEMENT as TOOLTIP_PLACEMENT, StatefulTooltip } from 'baseui/tooltip';
import { LabelSmall } from 'baseui/typography';
import { statefulTooltipSidePanelOverrides, TooltipContentLabel } from '../../side-panel/annotation-details/common/tooltip';
import { ICON_SIZE } from '../../side-panel/annotation-details/constants';
import type { AnnotationInfoT } from '../../side-panel/annotations/types';
type PropsT = {
  annotation: AnnotationInfoT;
  icon: React.ReactNode;
};
const Container = styled<'div', {
  isVisible: boolean;
}>('div', ({
  $theme,
  isVisible
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale200,
  opacity: isVisible ? 1 : 0.5,
  width: '100%'
}));
const IconContainer = styled('span', {
  flexBasis: '10%',
  justifyContent: 'flex-start',
  display: 'flex'
});
const NameContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingRight: $theme.sizing.scale550,
  width: '100%'
}));
const StatusIconsContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: $theme.sizing.scale300
}));
const NameLabel = styled(LabelSmall, ({
  $theme
}) => ({
  margin: 0,
  paddingRight: $theme.sizing.scale200,
  '::first-letter': {
    textTransform: 'capitalize'
  },
  wordBreak: 'break-all'
}));
export function AnnotationContent({
  annotation,
  icon
}: PropsT) {
  const [, theme] = useStyletron();
  const {
    isVisible,
    name,
    isLocked
  } = annotation;
  return <Container isVisible={isVisible}>
      <IconContainer>{icon}</IconContainer>
      <NameContainer>
        <NameLabel>{name}</NameLabel>
        <StatusIconsContainer>
          {isLocked && <StatefulTooltip placement={TOOLTIP_PLACEMENT.bottomLeft} overrides={statefulTooltipSidePanelOverrides} content={() => <TooltipContentLabel>
                  Annotation is locked. You cannot edit or delete it.
                </TooltipContentLabel>} showArrow>
              <Lock size={ICON_SIZE} color={theme.colors.contentPrimary} />
            </StatefulTooltip>}
          {!isVisible && <StatefulTooltip placement={TOOLTIP_PLACEMENT.bottomLeft} overrides={statefulTooltipSidePanelOverrides} content={() => <TooltipContentLabel>Annotation is hidden.</TooltipContentLabel>} showArrow>
              <Hide size={ICON_SIZE} color={theme.colors.contentPrimary} />
            </StatefulTooltip>}
        </StatusIconsContainer>
      </NameContainer>
    </Container>;
}